module.exports = __webpack_public_path__ + "img/guanyu_06.30febd1c.png";